<template>
	<v-container class="d-flex align-start" style="background: #fafafa" fluid>
		<v-row align="center">
			<v-col cols="8" sm="6">
				<v-autocomplete
					v-model="selectedFile"
					:loading="$store.forgeStore.state.loadingFiles"
					:items="$store.forgeStore.state.forgeFiles"
					:search-input.sync="searchForFiles"
					:item-disabled="isFileDisabled"
					item-text="name"
					item-value="id"
					return-object
					single-line
					outlined
					dense
					required
					label="Seleccione Archivo para Cargar"
					hide-details
					style="width: 100%"
				>
					<template v-slot:item="{ item, attrs, on }">
						<v-list-item v-bind="attrs" v-on="on">
							<v-list-item-avatar size="36" :color="isFileDisabled(item) ? 'grey lighten-3' : 'blue lighten-5'" rounded>
								<v-icon
									:color="isFileDisabled(item) ? 'grey lighten-1' : 'blue darken-1'"
									size="20"
								>
									{{ isFileProcessing(item) ? 'mdi-progress-clock' : 'mdi-file-cad' }}
								</v-icon>
							</v-list-item-avatar>

							<v-list-item-content>
								<v-list-item-title
									:class="isFileDisabled(item) ? 'grey--text text--lighten-1' : ''"
									class="font-weight-medium"
								>
									{{ item.name }}
								</v-list-item-title>

								<v-list-item-subtitle v-if="isFileProcessing(item)" class="d-flex align-center mt-1">
									<v-chip x-small color="orange lighten-4" text-color="orange darken-3" class="mr-1">
										<v-icon x-small left>mdi-clock-outline</v-icon>
										Procesando
									</v-chip>
									<span class="caption grey--text">Intenta en unos minutos</span>
								</v-list-item-subtitle>

								<v-list-item-subtitle v-else-if="!isFileDisabled(item)" class="d-flex align-center mt-1">
									<v-chip x-small color="green lighten-4" text-color="green darken-3">
										<v-icon x-small left>mdi-check-circle</v-icon>
										Listo para cargar
									</v-chip>
								</v-list-item-subtitle>
							</v-list-item-content>

							<v-list-item-action v-if="!isFileDisabled(item)">
								<div class="d-flex align-center">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small @click.stop="setMainProjectForgeModel(item)" :disabled="!checkPermissions(['assign_main_model'])" v-bind="attrs" v-on="on">
												<v-icon
													small
													:color="mainModelFileId === item.id ? '#EAB261' : '#BDBDBD'"
													>
														{{ mainModelFileId === item.id ? 'mdi-star' : 'mdi-star-outline' }}
													</v-icon>
											</v-btn>
										</template>
										<span>Marcar como modelo principal del proyecto.</span>
									</v-tooltip>

									<v-tooltip bottom v-if="checkPermissions(['delete_forge_model'])">
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small color="red" @click.stop="removeFileFromForge(item.id)" v-bind="attrs" v-on="on">
												<v-icon small>mdi-close</v-icon>
											</v-btn>
										</template>
										<span>Sacar archivo del visor. El archivo permanecerá en tu panel.</span>
									</v-tooltip>

									<v-icon color="blue darken-1" small>mdi-chevron-right</v-icon>
								</div>
							</v-list-item-action>
						</v-list-item>
					</template>

					<template v-slot:no-data>
						<v-list-item>
							<v-list-item-content>
								<v-list-item-title class="grey--text text-center">
									<v-icon class="mr-1">mdi-file-search-outline</v-icon>
									No se encontraron archivos
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col cols="4" sm="6">
				<v-btn class="custom-button-consultas" @click="onButtonClick" v-if="checkPermissions(['add_forge_model'])">
					<v-icon>mdi-upload</v-icon>
					<div>
						<p class="mb-0 font-weight-bold text-capitalize">Subir Archivo a Forge</p>
						<p class="mb-0 text-lowercase" style="font-size: 8px;">(.dwg, .dwfx, .dxf, .rvte)</p>
					</div>
				</v-btn>
				<input
					ref="uploader"
					class="d-none"
					type="file"
					accept=".dwg,.dwfx,.dxf,.rvt,.iam,.ipt,.stl,.obj,.f3d,.f2d,.igs,.iges,.step,.stp"
					@change="uploadNewFileToForge"
				>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { v4 as uuidv4 } from 'uuid'
import { removeFromForge, setProjectMainModel, getSupportedExtensions } from '@/helpers/api/forge'

export default {
	name: 'BlueprintHeader',
	data: () => ({
		searching: false,
		searchFile: null,
		showResults: false,
		searchResultsCount: 0,
		searchResult: [],
		searchForFiles: null
	}),
	computed: {
		project() {
			return this.$store.projectsStore.state.selectedProject
		},
		projectMainFile() {
			return this.$store.forgeStore.state.projectMainFile
		},
		mainModelFileId() {
			return this.projectMainFile?.file_id
		},
		selectedFile: {
			get () {
				return this.$store.forgeStore.state.forgeSelectedFile
			},
			set (value) {
				this.$store.forgeStore.commit('setForgeSelectedFile', value)
			}
		}
	},
	watch: {
		searchForFiles (val, prev) {
			// Evitar búsqueda si es una selección de archivo (cuando el valor coincide con el nombre del archivo)
			if(val && prev && val.length > 3){
				if (!this.selectedFile || this.selectedFile.name !== val) {
					this.searchFiles(val)
				}
			}
		},
		selectedFile(newVal) {
			// Limpiar el campo de búsqueda cuando se selecciona un archivo
			if (newVal) {
				this.searchForFiles = null
			}
		},
		project(newData) {
			if(newData && this.$store.projectsStore.state.selectedProject.id){
				this.$store.forgeStore.dispatch('fetchForgeFiles', {
					project_id: this.$store.projectsStore.state.selectedProject.id
				})
			}
		}
	},
	mounted(){
		if(this.$store.projectsStore.state.selectedProject){
			this.$store.forgeStore.dispatch('fetchForgeFiles', {
				project_id: this.$store.projectsStore.state.selectedProject.id
			})
		}
		this.getForgeSupportedExtensions()
	},
	methods:{
		isFileProcessing(file) {
			// Verifica si el archivo está en proceso (sin urn o translate)
			const forgeFile = file.forge_file
			return !forgeFile || (!forgeFile.urn && !forgeFile.translate)
		},
		isFileDisabled(file) {
			// Deshabilita el archivo si está procesándose
			return this.isFileProcessing(file)
		},
		closeResults(){
			this.showResults = false
			this.searching = false
		},
		searchFiles: _debounce(function(){ this.searchForString(this.searchForFiles) }, 800),
		async searchForString(searchString){
			if(!searchString || searchString.length < 3){ return false }
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				search: this.searchForFiles
			}
			this.$store.forgeStore.dispatch('fetchForgeFiles', data)
		},
		onButtonClick() {
			if(!this.checkPermissions(['add_forge_model'])){
				const msg = { message: 'No tienes permisos para subir archivos a Forge.', title: 'Permisos insuficientes', created: new Date(), type: 'error', icon: 'mdi-alert-circle', color: '#F4516C' }
				this.$store.globalStore.dispatch('addMessage', msg)
				return
			}
			this.$refs.uploader.click()
		},
		getForgeSupportedExtensions(){
			getSupportedExtensions().then(response => {
				const extensions = response.supported_extensions.map(ext => `.${ext}`)
				this.$refs.uploader.setAttribute('accept', extensions.join(','))
			})
		},
		removeFileFromForge(file_id){
			if(!this.checkPermissions(['delete_forge_model'])){
				const msg = { message: 'No tienes permisos para eliminar archivos de Forge.', title: 'Permisos insuficientes', created: new Date(), type: 'error', icon: 'mdi-alert-circle', color: '#F4516C' }
				this.$store.globalStore.dispatch('addMessage', msg)
				return
			}
			if(file_id){
				removeFromForge({file_id}).then(() => {
					this.$store.forgeStore.dispatch('fetchForgeFiles', {
						project_id: this.$store.projectsStore.state.selectedProject.id
					})
				})
			}
		},
		async setMainProjectForgeModel(file){
			if(!this.checkPermissions(['assign_main_model'])){
				this.$store.globalStore.dispatch('addMessage', { message: 'No tienes permisos para asignar el modelo principal.', title: 'Permisos insuficientes', created: new Date(), type: 'error', icon: 'mdi-alert-circle', color: '#F4516C' })
				return
			}
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				file_id: file.id
			}
			await setProjectMainModel(data)
			this.$store.forgeStore.dispatch('fetchForgeFiles', {
				project_id: this.$store.projectsStore.state.selectedProject.id
			})
		},
		uploadNewFileToForge(e){
			const file = e.target.files[0]
			const fileData = {
				type: 8,
				payload: {
					project_id: this.$store.projectsStore.state.selectedProject.id,
					blueprint: true
				},
				description: 'Archivo Forge',
				total: file.size,
				uuid: uuidv4(),
				file
			}
			this.$store.globalStore.commit('setFilesToUploadCenter', fileData)
		}
	}
};
</script>


<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
	
	/* Estilos para archivos procesándose */
	/deep/ .processing-file{
		opacity: 0.7;
	}
	
	/deep/ .processing-file .v-icon.mdi-spin {
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}
	
	/deep/ .opacity-50 {
		opacity: 0.5;
	}
	
	/deep/ .text-warning {
		color: #ff9800 !important;
		font-size: 12px;
	}

</style>